import { createApp } from 'vue'
import App from './App.vue'
import router from './router'   // 라우터 연결
import './views/css/style.css'
import './views/css/style_media.css'
import './views/js/style.js'

createApp(App).use(router).mount('#app')